export default function ModalText(selector) {
  const body = document.querySelector('body');
  const modals = document.querySelectorAll('dialog');
  const modalOpenButtons = document.querySelectorAll(selector);

  if (modals.length === 0 || modalOpenButtons.length === 0) {
    return;
  }

  modalOpenButtons.forEach((button) => {
    const modalId = button.dataset.modalTarget;
    const modal = document.querySelector(`#${modalId}`);
    const modalFirstFocus = modal.querySelector(".o-modal-foundation__inner");
    if (!modal) return;
    button.addEventListener('click', (event) => {
      // すべてのデフォルト動作とバブリングを停止
      event.preventDefault();
      event.stopImmediatePropagation();
      // 現在開いているモーダルがあれば閉じる
      const currentOpenModal = document.querySelector('dialog[open]');
      if (currentOpenModal) {
        currentOpenModal.close();
      }

      // 複数のモーダルが開いている時用
      // 少し遅延させて新しいモーダルを開く（アニメーション等の兼ね合いで）
      setTimeout(() => {
        modal.showModal();
        modalFirstFocus.focus();
        body.style.overflow = 'hidden';
      }, 100);

      modal.showModal();
      modalFirstFocus.focus();
      body.style.overflow = 'hidden';
    });
  });

  // モーダル外がクリックされたら、モーダルを閉じる
  modals.forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (!event.target.closest('.o-modal-foundation__inner')) {
        modal.close();
        body.style.overflow = 'visible';
      }
    });
  });
}
